module.exports = __webpack_public_path__ + "img/bidsShort.502fa2c4.svg";